export default (Alpine) => {
  Alpine.data("transition", () => ({
    scrollY: 0,
    inView: false,
    inViewImage: false,
    scrollSectionY: 0,

    init() {
      this.section = this.$el;
      window.addEventListener("scroll", this.scrolling.bind(this));
      window.addEventListener("resize", this.scrolling.bind(this));
      this.scrolling(); // initialize
    },

    scrolling() {
      this.scrollY = window.scrollY;

      const rect = this.section.getBoundingClientRect();
      const sectionHeight = rect.height || this.section.offsetHeight;
      const windowHeight = window.innerHeight;

      // distance from viewport top to section top (negative = section scrolled past)
      const sectionTop = rect.top;
      const sectionBottom = rect.bottom;

      // section is visible at all when bottom > 0 and top < windowHeight
      const isVisible = sectionBottom > 0 && sectionTop < windowHeight;
      this.inView = isVisible;

      if (isVisible) {
        // progress between "just entered" (bottom = 0) and "just left" (top = windowHeight)
        const totalScrollDistance = windowHeight + sectionHeight;
        const scrolled = windowHeight - sectionTop;

        const progress = scrolled / totalScrollDistance;

        // clamp 0–1 and convert to percentage
        this.scrollSectionY = Math.min(1, Math.max(0, progress)) * 100;
      } else if (sectionTop >= windowHeight) {
        this.scrollSectionY = 0; // not yet entered
      } else {
        this.scrollSectionY = 100; // fully exited
      }
    },
  }));
};
